import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  background-color: ${props => props.color};
  border: 0;
  height: 2px;
  margin: 0;
  width: ${props => props.width};
  align-self: ${props => props.align};
  
  @media (max-width: 972px){
    align-self: center;
  }
  
`
const Line = ({ width, align, color }) => (
  <Container width={width} align={align} color={color} />
)


Line.propTypes = {
  width: PropTypes.string,
  align: PropTypes.string,
  color: PropTypes.string
}
Line.defaultProps = {
  width: '14px',
  align: 'center',
  color: '#1B7CDD',
}
export default Line
